import { useTranslation } from 'react-i18next';

import SvgIcon from '@/components/SvgIcon/SvgIcon';
import { useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';

import styles from './RunOutChecks.module.sass';

export interface RunOutChecksProps {
  onClick: () => void;
}

export const RunOutChecks = ({ onClick }: RunOutChecksProps) => {
  const { t } = useTranslation();

  const { data: userData } = useAppSelector(userSelectors.getUserSlice);

  const needTopUpBalance = userData?.extBalance === 0;

  if (!needTopUpBalance) {
    return null;
  }

  return (
    <button type="button" className={styles.panel} onClick={onClick}>
      <div className={styles.title}>
        {t('translation.run_out_checks.title')}
      </div>

      <div className={styles.info}>
        <SvgIcon name="aml" className={styles.aml} />
        {t('translation.run_out_checks.buy_check_from')}
        <SvgIcon name="arrow-right" className={styles.arrow} />
      </div>
    </button>
  );
};
